export { CONFIRMATION_STRATEGY } from '@toruslabs/base-controllers';

const WS_EMBED_BUILD_ENV = {
  PRODUCTION: "production",
  STAGING: "staging",
  DEVELOPMENT: "development",
  TESTING: "testing"
};
const BUTTON_POSITION = {
  BOTTOM_LEFT: "bottom-left",
  TOP_LEFT: "top-left",
  BOTTOM_RIGHT: "bottom-right",
  TOP_RIGHT: "top-right"
};

export { BUTTON_POSITION, WS_EMBED_BUILD_ENV };
